import { useMemo } from 'react';

import _ from 'lodash';

import {
  FeatureAppTrackingEvent,
  FeatureAppTrackingManager,
  TrackingEvent
} from '../types/tagging';
import { useFeatureServices } from './use-feature-services';


const defaultTrackingEvent: FeatureAppTrackingEvent = {
  eventInfo: {
    pageName: 'MiniMOFA',
    pageCategory: 'MiniMOFA',
  },

  environment: {
    featureAppIdAppVersion: process.env.APPVERSION,
    featureAppId: 'MiniMOFA-D6-US',
  },
};

export function getDefaultTrackingEvent() {
  return _.cloneDeep(defaultTrackingEvent);
}

function buildTrackingEvent(
  cusTrackEvent?: FeatureAppTrackingEvent,
): FeatureAppTrackingEvent {
  let trackingEvent: FeatureAppTrackingEvent;

  if (cusTrackEvent) {
    trackingEvent = _.cloneDeep(cusTrackEvent);
  } else {
    trackingEvent = _.cloneDeep(defaultTrackingEvent);
  }

  return trackingEvent;
}

export function getTrackEventClone(): FeatureAppTrackingEvent {
  return _.cloneDeep(defaultTrackingEvent);
}

export function useTrackingManager(): FeatureAppTrackingManager {
  const trackingManager = useFeatureServices()['tracking']!;

  return useMemo((): FeatureAppTrackingManager => {
    function track(action: string, event: FeatureAppTrackingEvent): void {
      if (trackingManager) {
        trackingManager.track(action, event as unknown as TrackingEvent);
      }
    }
    return {
      trackMaintenanceGlobalEvent(
        event: string,
        trackEvent?: FeatureAppTrackingEvent,
      ): void {
        track(event, buildTrackingEvent(trackEvent));
      },
    };
  }, [trackingManager]);
}
